import React from "react";
import TotalLiveSession from "../components/pages/Dashboard/TotalLiveSession";
import SideNav from "../components/SideNav/sideNav";
import Header from "../components/Header/hearder";
import { Wrapper } from "./layout.styles";

const TotalLiveSessionLayout = () => {
  return (
    <React.Fragment>
      <Header />
      <Wrapper>
        <SideNav />
        <div style={{ margin: "70px 0px 0px 200px", width: "100%" }}>
          <TotalLiveSession />
        </div>
      </Wrapper>
    </React.Fragment>
  );
};

export default TotalLiveSessionLayout;
